












































import { defineComponent, onMounted, watch, ref } from '@vue/composition-api';
import { useActivityGroup } from '@/bundles/ActivityGroup/composables/useActivityGroup';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';

import LoadVoiceBuilderForm from '@/bundles/ActivityGroup/components/LoadVoiceBuilderForm.vue';
import draggable from 'vuedraggable';
import { debounce } from '@/bundles/App/helpers';

export default defineComponent({
  name: 'VoiceBuilderList',

  components: {
    LoadVoiceBuilderForm,
    draggable,
  },

  setup () {
    const { groupItems, loadItemInGroup, deleteFromGroup, bulkOrderUpdate } = useActivityGroup();
    function loadItemInGroupWrapper() {
      loadItemInGroup(ActivityGroupType.voice_builder);
    }
    function bulkUpdateWrapper() {
      bulkOrderUpdate({ items: groupItems.value.map((item) => ({ id: item.group_id, order: item.order })) });
    }
    const debouncedUpdate = debounce(bulkUpdateWrapper, 500);
    onMounted(() => {
      loadItemInGroupWrapper();
    });
    watch(groupItems, function () {
      groupItems.value.forEach((item, index) => {
        item.order = index;
      });
      debouncedUpdate();
    }, { deep: true });

    const deleteDialog = ref(false);
    const itemToDelete = ref(null);

    function openDeleteDialog(item: any) {
      itemToDelete.value = item;
      deleteDialog.value = true;
    }

    async function confirmDelete() {
      if (itemToDelete.value) {
        await deleteFromGroup(itemToDelete.value.group_id);
        await loadItemInGroupWrapper();
        deleteDialog.value = false;
      }
    }

    return {
      groupItems,
      loadItemInGroupWrapper,
      deleteDialog,
      openDeleteDialog,
      confirmDelete,
    };
  },
});
